<div class="auctions-calendar-page">
  <!-- Breadcrumbs -->
  <app-bread-crumbs [breadcrumbs]="breadcrumbs"></app-bread-crumbs>

  <div class="container">
    <!-- Page Header -->
    <div class="page-header">
      <div class="header-content">
        <h1 class="page-title">
          {{ "auctions_calendar.title" | translate }}
        </h1>
        <p class="page-subtitle">
          {{ "auctions_calendar.subtitle" | translate }}
        </p>
      </div>
    </div>

    <!-- Loading State -->
    @if (isLoading) {
      <div class="loading-state">
        <div class="spinner-container">
          <div class="spinner"></div>
          <p>{{ "auctions_calendar.messages.loading" | translate }}</p>
        </div>
      </div>
    }

    <!-- Error State -->
    @if (hasError) {
      <div class="error-state">
        <div class="error-container">
          <svg
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="error-icon"
            >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="2"
              />
              <path
                d="M12 8V12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                />
                <circle cx="12" cy="16" r="1" fill="currentColor" />
              </svg>
              <h3>{{ "auctions_calendar.messages.error_title" | translate }}</h3>
              <p class="error-message">{{ errorMessage }}</p>
              <button
                class="btn btn-primary retry-button"
                (click)="retryLoadAuctions()"
                >
                {{ "auctions_calendar.messages.retry" | translate }}
              </button>
            </div>
          </div>
        }

        <!-- Filters Section -->
        @if (!isLoading && !hasError) {
          <div class="filters-section">
            <div class="filter-card">
              <div class="filter-row">
                <!-- Filter Selector -->
                <div class="filter-item filter-selector">
                  <label for="filterSelect">
                    {{ "auctions_calendar.filters.filter_by" | translate }}
                  </label>
                  <select
                    id="filterSelect"
                    name="filterSelect"
                    class="form-select"
                    [(ngModel)]="selectedFilter"
                    (change)="onFilterChange()"
                    >
                    @for (option of filterOptions; track option) {
                      <option [value]="option">
                        {{ getTranslatedFilter(option) }}
                      </option>
                    }
                  </select>
                </div>
                <!-- Search Filter -->
                <div class="filter-item search-filter">
                  <label for="search">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      >
                      <path
                        d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        />
                        <path
                          d="M15.75 15.75L12.4875 12.4875"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          />
                        </svg>
                        {{ "auctions_calendar.filters.search" | translate }}
                      </label>
                      <input
                        type="text"
                        id="search"
                        name="search"
                        class="form-control"
                        [(ngModel)]="searchTerm"
                        (ngModelChange)="onFilterChange()"
              [placeholder]="
                'auctions_calendar.filters.search_placeholder' | translate
              "
                        />
                      </div>
                    </div>
                    <!-- Results Count -->
                    <div class="results-count">
                      <p>
                        <strong>{{ filteredAuctions.length }}</strong>
                        {{
                        filteredAuctions.length === 1
                        ? ("auctions_calendar.labels.found_singular" | translate)
                        : ("auctions_calendar.labels.found_plural" | translate)
                        }}
                        @if (selectedFilter !== 'Upcoming') {
                          {{ "auctions_calendar.labels.in" | translate }}
                        }
                      </p>
                    </div>
                  </div>
                </div>
              }

              <!-- Timeline View -->
              @if (!isLoading && !hasError) {
                <div>
                  @if (filteredAuctions.length > 0) {
                    <app-timeline-view
                      [auctions]="filteredAuctions"
                      [translations]="translations"
                      [locale]="localeService.locale"
                      [appDir]="localeService.dir"
                    ></app-timeline-view>
                  }
                  <!-- Empty State -->
                  @if (filteredAuctions.length === 0) {
                    <div class="empty-state">
                      <div class="empty-container">
                        <svg
                          width="64"
                          height="64"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="empty-icon"
                          >
                          <rect
                            x="3"
                            y="6"
                            width="18"
                            height="15"
                            rx="2"
                            stroke="currentColor"
                            stroke-width="2"
                            />
                            <path d="M3 10H21" stroke="currentColor" stroke-width="2" />
                            <path
                              d="M8 3V6"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              />
                              <path
                                d="M16 3V6"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                />
                              </svg>
                              <h3>
                                {{ "auctions_calendar.messages.no_auctions_title" | translate }}
                              </h3>
                              <p>
                                {{ "auctions_calendar.messages.no_auctions_message" | translate }}
                              </p>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
